import { CardsSet } from '@hg/stylizator/components'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { useCTAAttributes } from 'app/blocks/hooks/useCTA'
import { ReactBlocks } from 'app/helpers/Blocks'
import { ICTAAttributes } from 'app/helpers/CTAInspectorPanels'

export interface IAttributes
  extends Omit<React.ComponentProps<typeof CardsSet>, 'disclaimer' | 'callToCation' | 'secondaryCallToAction'>,
    ICTAAttributes {
  iconPosition: string
  disclaimer: string
}

const CardsSetBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  const { callToAction, secondaryCallToAction } = useCTAAttributes(attributes)

  return (
    <CardsSet
      title={attributes.title}
      subtitle={attributes.subtitle}
      background={attributes?.background ?? 'white'}
      columns={attributes?.columns ?? 3}
      disclaimer={parse(attributes?.disclaimer ?? '')}
      callToAction={callToAction}
      secondaryCallToAction={secondaryCallToAction}
    >
      <ReactBlocks innerBlocks={props.innerBlocks} />
    </CardsSet>
  )
}

export default CardsSetBlock
